import { render, staticRenderFns } from "./forgotName.vue?vue&type=template&id=20f7cad4&scoped=true"
import script from "./forgotName.vue?vue&type=script&lang=js"
export * from "./forgotName.vue?vue&type=script&lang=js"
import style0 from "./forgotName.vue?vue&type=style&index=0&id=20f7cad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7cad4",
  null
  
)

export default component.exports